import { render } from "./ideaCode.vue?vue&type=template&id=c79695a4&scoped=true"
import script from "./ideaCode.vue?vue&type=script&lang=js"
export * from "./ideaCode.vue?vue&type=script&lang=js"

import "./ideaCode.vue?vue&type=style&index=0&id=c79695a4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79695a4"]])

export default __exports__